import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function EmploymentPage() {
    const [labourGovernmentArray, setLabourGovernmentArray] = useState<Service[]>([]);
    const [labourNgosArray, setLabourNgosArray] = useState<Service[]>([]);
    const [labourEuropeanArray, setLabourEuropeanArray] = useState<Service[]>([]);
    const [labourInstitutionsArray, setLabourInstitutionsArray] = useState<Service[]>([]);

    const getLabourGovernment = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕργατοΚυβερνητικοί Οργανισμοί");

    const getLabourNgos = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕργατοΜη Κυβερνητικοί Οργανισμοί");

    const getLabourEuropean = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕργατοΕυρωπαϊκοί Οργανισμοί");

    const getLabourInstitutions = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕργατοΙδρύματα - Οργανισμοί");

    useEffect(() => {
        setLabourGovernmentArray(getLabourGovernment());
    }, []);

    useEffect(() => {
        setLabourNgosArray(getLabourNgos());
    }, []);

    useEffect(() => {
        setLabourEuropeanArray(getLabourEuropean());
    }, []);

    useEffect(() => {
        setLabourInstitutionsArray(getLabourInstitutions());
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const tabColor = useColorModeValue("primary", "light");

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={tabColor}>
                <TabList flex="1">
                    <Tab fontWeight="bold">Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Μη Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ευρωπαϊκοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ιδρύματα - Οργανισμοί</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {labourGovernmentArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {labourNgosArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {labourEuropeanArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {labourInstitutionsArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}